import { BaseMetadataType } from "../Api/Types/base-metadata-type";
import { DbAssetObjectInfos } from "../Api/Types/db-asset-object-infos";
import { DbMetadataFieldInfos } from "../Api/Types/db-metadata-field-infos";
import { ObjectStatus } from "../Api/Types/object-status";
import { ObjectType } from "../Api/Types/object-type";
import { GetMetadataByTagName } from "./asset-object-utils";
import GlobalConst from "./Constants/globals";

export function GetAllChildMetadataDistinctByTagNameAndType(
  asset: DbAssetObjectInfos,
  tagName: string,
  type: ObjectType[] | null,
  isLang: boolean = false,
  isFullLang: boolean = false,
  sessionMetadatas?: DbMetadataFieldInfos[],
  contentSubTypes: string[] | null = null
) {
  let metadaList: string[] = [];
  var metadata: any;
  asset?.childObjects?.forEach((child: DbAssetObjectInfos) => {
    if (
      child.layer === "Asset" &&
      child.classification === "Mezz" &&
      child.status === ObjectStatus.Accepted &&
      child.type !== null &&
      type?.includes(child.type) &&
      (!contentSubTypes || contentSubTypes.includes(GetMetadataByTagName(child, "contentSubType")?.value))
    ) {
      if (isLang) metadata = GetMetadataByTagName(child, tagName, sessionMetadatas)?.value.value;
      if (isFullLang) metadata = GetMetadataByTagName(child, tagName, sessionMetadatas)?.value.label;
      if (!isFullLang && !isLang) metadata = GetMetadataByTagName(child, tagName, sessionMetadatas)?.value;
      if (!metadaList.includes(metadata) && metadata !== undefined && metadata !== null) {
        metadaList.push(metadata);
      }
    }
  });

  return metadaList;
}

export function ComputeMetadataBaseType(type: BaseMetadataType) {
  return GlobalConst.dbBaseTypeBeginning + type + GlobalConst.dbBaseTypeEnding;
}

export function GetValueBaseTypeFromMetaBaseType(type: BaseMetadataType): BaseMetadataType {
  switch (type) {
    case BaseMetadataType.DbAnyObjectMultiMetadataValueInfos:
      return BaseMetadataType.DbAnyObjectMetadataValueInfos;
    case BaseMetadataType.DbDateTimeMultiMetadataValueInfos:
      return BaseMetadataType.DbDateTimeMetadataValueInfos;
    case BaseMetadataType.DbDoubleMultiMetadataValueInfos:
      return BaseMetadataType.DbDoubleMetadataValueInfos;
    case BaseMetadataType.DbGenreMultiMetadataValueInfos:
      return BaseMetadataType.DbGenreMetadataValueInfos;
    case BaseMetadataType.DbLanguageCodeMultiMetadataValueInfos:
      return BaseMetadataType.DbLanguageCodeMetadataValueInfos;
    case BaseMetadataType.DbLongMultiMetadataValueInfos:
      return BaseMetadataType.DbLongMetadataValueInfos;
    case BaseMetadataType.DbPairStringStringMultiMetadataValueInfos:
      return BaseMetadataType.DbPairStringStringMetadataValueInfos;
    case BaseMetadataType.DbStringMultiMetadataValueInfos:
      return BaseMetadataType.DbStringMetadataValueInfos;
    case BaseMetadataType.DbTerritoryCodeMultiMetadataValueInfos:
      return BaseMetadataType.DbTerritoryCodeMetadataValueInfos;
    default:
      return type;
  }
}

export function ComputeValueBaseTypeFromMetaBaseType(type: BaseMetadataType): string {
  if (type === BaseMetadataType.DbStringMultiByEpisodeMetadataValueInfos)
    return "VDM.AirLab.Sdk.Core.Types.CommonTypes.StringMultiByEpisodeMetadataInfos, VDM.AirLab.Sdk.Core";
  return GlobalConst.dbBaseTypeBeginning + GetValueBaseTypeFromMetaBaseType(type) + GlobalConst.dbBaseTypeEnding;
}

export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result as string);
    };

    reader.onerror = () => {
      reject(new Error("Failed to read the file!"));
    };

    const blob = new Blob([file], { type: file.type });
    reader.readAsText(blob);
  });
}

export function readFileAsBinaryString(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      if (result && result instanceof ArrayBuffer) {
        const byteArray = new Uint8Array(result);
        const base64String = arrayBufferToBase64(byteArray);
        resolve(base64String);
      } else reject(new Error("Failed to read file as ArrayBuffer"));
    };

    reader.onerror = () => {
      reject(new Error("Failed to read the file!"));
    };

    reader.readAsArrayBuffer(file);
  });
}

function arrayBufferToBase64(buffer: Uint8Array): string {
  let binary = "";
  const len = buffer.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(buffer[i]);
  }
  return btoa(binary);
}
